export interface DateInfo {
  stdDate: string;
  curDateTime: string;
}
export enum MeetingRoomLocation {
  IHQ = "IHQ",
  FACTORY = "factory",
  VENTURE = "venture",
}

export interface MeetingRoomInfo {
  id: string;
  displayName: string;
  capacity: number;
  mail: string;
}
export interface FloorInfo {
  floor: number;
  name: string;
}
export interface MeetingRoomStatusInfo {
  id: string;
  isAvailable: boolean;
  name: string;
  floorInfo: FloorInfo;
  roomInfo: MeetingRoomInfo;
}

export interface SelectedLocationInfo {
  prevLocation: MeetingRoomLocation | null;
  curLocation: MeetingRoomLocation;
}
export interface Attendee {
  email: string;
  name: string;
}

export interface Organizer {
  email: string;
  name: string;
}
export interface MeetingRoomEventListItem {
  attendees: Attendee[];
  end: string;
  id: string;
  isAllDay: boolean;
  isOrganizer: boolean;
  location: string;
  organizer: Organizer;
  start: string;
  subject: string;
}
export type MeetingRoomEventList = Record<string, MeetingRoomEventListItem[]>;
export interface MeetingRoomEventListInfo {
  initAllEventList: MeetingRoomEventList;
  todayEventList: MeetingRoomEventList;
  eventList: MeetingRoomEventList;
  isInit: boolean;
}

export interface OutlookDeepLinkParam {
  key: string;
  value: string;
}

export interface RoomColorInfo {
  room: string;
  color: string;
}
